import { render, staticRenderFns } from "./ModalHistory.vue?vue&type=template&id=4d8174c6"
import script from "./ModalHistory.vue?vue&type=script&lang=js"
export * from "./ModalHistory.vue?vue&type=script&lang=js"
import style0 from "./ModalHistory.vue?vue&type=style&index=0&id=4d8174c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports